module.exports = __webpack_public_path__ + "img/rj.cfe02e6b.svg";